<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <h2>
                Vende, Cobra y Adelanta dinero de tus ventas con unos pocos clicks
            </h2>
            <!-- <p><span>Sea que estés en tu hogar o en tu lugar favorito en el mundo, tus ventas no se detienen.</span></p> -->
            <p>Triidy es una plataforma de comercio electrónico con todo lo que necesitas para comenzar, gestionar y crecer tu negocio en internet; brindándote acceso a proveedores dropshipping, servicios logísticos y herramientas financieras.
            </p>
            <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
            <button class="btn" (click)="clickM()">Regístrate Ahora</button>
        </div>
        <div class="col right">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/HombreTriidy-new.png" alt="">
            <img class="globo1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo1-new.png" alt="">
            <img class="globo2" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo2-new.png" alt="">
            <img class="globo3" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo3-new.png" alt="">
            <img class="globo4" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo4-new.png" alt="">

        </div>
    </div>
    <!--     <div class="row secc2">
        <p>Vende como quieras, <span>Triidy</span> se integra con</p>
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Shopi-new2.png" alt="">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Face-new2.png" alt="">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Insta-new2.png" alt="">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Wasa-new2.png" alt="">
    </div> -->
    <div class="row secc3">
        <img class="figur1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Elipse3-new.png" alt="">
        <img class="figur2" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Stroke3-new.png" alt="">
        <img class="figur3" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Stroke3-2-new.png" alt="">
        <img class="figur4" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Elipse3-new.png" alt="">
        <div class="row cuad-int">
            <div class="col left">
                <h2>Gestiona tus ventas más rápido</h2>
                <p>Con nuestro sistema <span>Dropshipping</span> podrás acceder a más de 1000 productos y 180 proveedores.
                </p>
                <p>Los proveedores en Triidy despachan los pedidos al cliente final, tu solo te encargas de vender y recibir el dinero de las ventas.</p>
                <p><span>Así de fácil, sin tener los productos físicos.</span></p>
            </div>
            <div class="col right">
                <iframe class="video" width="560" height="315" src="https://www.youtube.com/embed/ooC6s6pvy5A" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <img class="fondo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Fondo3-new.png" alt="">
            </div>
        </div>
    </div>
    <div class="row secc4">
        <div class="col left">
            <img class="fondo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Fondo4-new.png" alt="">
        </div>
        <div class="col right">
            <h2>Todo tu dinero en un solo lugar</h2>
            <h3>Administra tu dinero de forma segura, fácil y ágil.</h3>
            <p>Somos la <b>solución</b> digital #1 en Colombia; tendrás diferentes alternativas para gestionar tu negocio de forma óptima, ahorrando costos logísticos hasta en un 80% y aumentando tus ventas hasta en un 150%, siempre teniendo control y visibilidad
                financiera de tu ecommerce para que nunca pares de vender.</p>
            <p><span routerLink="/somos-triidy">Saber mas <i class="fas fa-arrow-right"></i></span></p>
            <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
            <button class="btn" (click)="clickM()">Regístrate Ahora</button>
        </div>
    </div>
    <div class="row secc5">
        <p>Estamos cambiando el comercio electrónico en América Latina, ¡Súmate!</p>
        <div class="metrica">
            <h2>+5.000</h2>
            <p>Usuarios</p>
        </div>
        <div class="metrica">
            <h2>+2.000</h2>
            <p>Productos disponibles</p>
        </div>
        <div class="metrica">
            <h2>+1.250.000</h2>
            <p>Transacciones realizadas</p>
        </div>
        <div class="metrica">
            <h2>+1.100</h2>
            <p>Ciudades y municipios</p>
        </div>
    </div>
    <div class="row secc6">
        <div class="col left">
            <h2>Usar Triidy es simple</h2>
            <h3>Sin costos fijos mensuales</h3>
            <p>En Triidy existimos para ayudar a los emprendedores digitales a descubrir su verdadero potencial, despachando a tiempo y ahorrando costos en logística.</p>
            <p><span routerLink="/beneficios">Saber mas <i class="fas fa-arrow-right"></i></span></p>
            <p>Nuestra plataforma esta disponible en:</p>
            <img class="" (click)="descargaAnd()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/GooglePlay-new.png" alt="">
            <img class="" (click)="descargaWin()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Windows-new.png" alt="">
        </div>
        <div class="col right">
            <img class="fondo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Fondo6-new.png" alt="">
        </div>
    </div>
    <div class="row secc7">
        <h2>¡Empezar en Triidy es muy fácil!</h2>
        <h3>Así funciona Triidy</h3>
        <div class="col card navegador" *ngFor="let fun of funciona">
            <img class="fondo" [src]="fun.imagen" alt="">
            <p>{{ fun.titulo }}</p>
            <hr class="oculto linea">
            <span class="oculto">{{ fun.texto }}</span>
        </div>
        <div id="carouselExampleControls" class="carousel slide mobile" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let fun of funciona" [ngClass]="{'active':fun.id === 1}">
                    <div class="card">
                        <img class="fondo" [src]="fun.imagen" alt="">
                        <p>{{ fun.titulo }}</p>
                        <hr class="oculto linea">
                        <span class="oculto">{{ fun.texto }}</span>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </a>
        </div>
    </div>
    <div class="row secc8">
        <h2>Ventajas y Beneficios</h2>
        <p>Descubre como nuestra tecnología esta revolucionando la forma de vender y generar ganancias.</p>
        <carousel class="carrou navegador" [overflowCellsLimit]="3" [loop]="true" [cellWidth]="200" [cellsToShow]="3" [autoplay]="true">
            <div class="carousel-cell" *ngFor="let ben of Beneficios">
                <div class="card2">
                    <img class="image" [src]="ben.imagen" alt="">
                    <h3>{{ ben.titulo }}</h3>
                    <p>{{ ben.parrafo }}</p>
                </div>
            </div>
        </carousel>
        <div id="carouselExampleControls2" class="carousel slide mobile" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let ben of Beneficios" [ngClass]="{'active':ben.id === 1}">
                    <div class="card2">
                        <img class="image" [src]="ben.imagen" alt="">
                        <h3>{{ ben.titulo }}</h3>
                        <p>{{ ben.parrafo }}</p>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleControls2" role="button" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls2" role="button" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </a>
        </div>
    </div>
    <div class="row secc9">
        <div class="col left">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Santiago-new.png" alt="">
            <div>
                <p>
                    Con Triidy he llevado mi comunidad a más de 5000 mil ventas mensuales, logrando potenciar su crecimiento y conectando todo lo que necesitan como proveedores de productos, transportadoras y recursos financieros
                </p>
                <h4>Santiago García</h4>
                <h6>Líder comunidad NDC</h6>
                <p><img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Star9-new.png" alt="">
                </p>
            </div>
        </div>
        <div class="col right">
            <div>
                <p>
                    Mi prioridad siempre ha sido mi familia, gracias a Triidy he podido hacer ecommerce desde la comodidad de mi hogar y compartir más tiempo con mis hijos. En tan solo unos meses logré vender mis primeros 10.000 USD haciendo Dropshipping
                </p>
                <h4>Nataly Restrepo</h4>
                <h6>Tienda Menta</h6>
                <p><img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Star9-new.png" alt="">
                </p>
            </div>
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Nataly.png" alt="">
        </div>
    </div>
    <div class="row secc10">
        <h2>Los medios de comunicación confían en Triidy</h2>
        <div class="medium">
            <div class="in-medium">
                <span>Viernes, 5 de noviembre de 2021</span>
                <div class="row">
                    <div class="col-8 text">
                        Plataforma Triidy apuesta por acelerar el desarrollo digital de los emprendimientos
                    </div>
                    <div class="col imag">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/la_republica_trii_3.png" alt="Triidy">
                    </div>
                </div>
                <span class="more"><a
                        href="https://www.larepublica.co/empresas/plataforma-triidy-apuesta-por-acelerar-el-desarrollo-digital-de-los-emprendimientos-3257887"
                        target="_blank">Ver más <i class="fas fa-arrow-right"></i></a></span>
            </div>
            <div class="in-medium">
                <span>Viernes, 5 de noviembre de 2021</span>
                <div class="row">
                    <div class="col-8 text">
                        La plataforma que le facilita la vida a los emprendimientos
                    </div>
                    <div class="col imag">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/portafolio_trii_3.png" alt="Triidy">
                    </div>
                </div>
                <span class="more"><a
                        href="https://www.portafolio.co/negocios/emprendimiento/triidy-la-plataforma-que-le-facilita-la-vida-a-los-emprendimientos-559330"
                        target="_blank">Ver más <i class="fas fa-arrow-right"></i></a></span>
            </div>
            <div class="in-medium">
                <span>Entrevista</span>
                <div class="row">
                    <div class="col-8 text">
                        Triidy brinda herramientas para incrementar las ventas de un comercio digital
                    </div>
                    <div class="col imag">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/caracol_trii_3.png" alt="Triidy">
                    </div>
                </div>
                <span class="more"><a href="https://youtu.be/NsnwDAnsnjw" target="_blank">Ver entrevista <i
                            class="fas fa-arrow-right"></i></a></span>
            </div>
            <div class="in-medium">
                <span>Entrevista</span>
                <div class="row">
                    <div class="col-8 text">
                        Triidy ofrece a los empresarios y emprendedores una billetera digital
                    </div>
                    <div class="col imag">
                        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ntn_trii_3.png" alt="Triidy">
                    </div>
                </div>
                <span class="more"><a href="https://youtu.be/xBqzSvRZnRo" target="_blank">Ver entrevista <i
                            class="fas fa-arrow-right"></i></a></span>
            </div>
        </div>
    </div>
    <div class="row secc11">
        <img class="figure1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Elipse3-new.png" alt="">
        <img class="figure2" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Stroke3-new.png" alt="">
        <div class="cuad-int">
            <h2>Contamos con el apoyo de los mejores aliados</h2>
            <div class="ali">
                <div class="ali-item">
                    <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/impact_trii_3.png" alt="Triidy">
                </div>
                <div class="ali-item">
                    <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/apps_trii_3.png" alt="Triidy">
                </div>
                <div class="ali-item">
                    <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/mintic_trii_3.png" alt="Triidy">
                </div>
                <div class="ali-item">
                    <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/fintech_trii_3.png" alt="Triidy">
                </div>
            </div>
        </div>
    </div>
    <div class="row secc12">
        <div class="col imag">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/pc_trii_3.png" alt="Triidy">
        </div>
        <div class="col text">
            <h2>Gestiona y organiza tu tienda virtual desde tu computador o desde tu celular.</h2>
            <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
            <button class="btn" (click)="clickM()">Regístrate Ahora</button>
        </div>
    </div>
</div>